/**
 * Streak Badge Component
 *
 * Displays the current streak with gentle gamification.
 */

import { Flame } from 'lucide-react';
import { useStreak } from '@have-done/shared';

export function StreakBadge() {
  const streak = useStreak();

  // Loading state
  if (streak === undefined) {
    return (
      <div className="inline-flex items-center gap-1.5 rounded-full bg-bg-tertiary px-3 py-1.5 animate-pulse">
        <Flame className="h-4 w-4 text-text-tertiary" />
        <span className="text-sm font-medium text-text-tertiary">...</span>
      </div>
    );
  }

  // Not logged in or no streak data
  if (streak === null) {
    return null;
  }

  const { currentStreak, longestStreak } = streak;

  // Determine streak level for styling
  const getStreakStyle = () => {
    if (currentStreak >= 30) return 'bg-accent text-white';
    if (currentStreak >= 7) return 'bg-accent/20 text-accent-dark';
    if (currentStreak >= 3) return 'bg-primary/20 text-primary-dark';
    return 'bg-bg-tertiary text-text-secondary';
  };

  const getFireColor = () => {
    if (currentStreak >= 30) return 'text-white';
    if (currentStreak >= 7) return 'text-accent';
    if (currentStreak >= 3) return 'text-primary';
    return 'text-text-tertiary';
  };

  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 ${getStreakStyle()}`}
      title={`Current streak: ${currentStreak} days. Best: ${longestStreak} days.`}
    >
      <Flame className={`h-4 w-4 ${getFireColor()}`} aria-hidden="true" />
      <span className="text-sm font-medium">
        {currentStreak} day{currentStreak !== 1 ? 's' : ''}
      </span>
    </div>
  );
}
